; (function () {
	"use strict";

	/**
	 * Returns the default Splide configuration for this block.
	 *
	 * The options object is kept in the plugin so the block works independently.
	 * A child theme can modify these values through the BMRelatedPosts.splideOptions callback.
	 */
	function getSplideOptions(element) {
		let options = {
			perPage: 1,
			perMove: 1,
			gap: '15px',
			type: 'slide',
			fixedWidth: '270px',
			pagination: false,
			arrows: false,
			mediaQuery: 'min',
			breakpoints: {
				550: {
				  perPage: 2,
				},
				1000: {
					perPage: 2,
				},
				1200: {
					perPage: 3,
					fixedWidth: false,
				},
			}
		};

		/**
		 * Allow the active theme to override or extend the default Splide settings
		 */
		if (window.BMRelatedPosts && typeof window.BMRelatedPosts.splideOptions === 'function') {
			const mergedOptions = window.BMRelatedPosts.splideOptions(options, element);

			// Keep plugin defaults if an override returns an invalid value
			if (mergedOptions && typeof mergedOptions === 'object') {
				options = mergedOptions;
			}
		}

		return options;
	}

	function RelatedPostsSlider() {
		var fn = {
			init: function () {
				fn.initSliders();
			},

			initSliders: function() {
				jQuery('.related-posts .splide').each(function(index, element) {
					fn.initSlider(element);
				})
			},

			initSlider: function (element) {
				let splide = new Splide(element, getSplideOptions(element)).mount();

				let prevButton = element.querySelector('.related-posts__nav-button--prev');
				let nextButton = element.querySelector('.related-posts__nav-button--next');

				// Add event listeners
				prevButton.addEventListener('click', function () {
					splide.go('<'); // Move to the previous slide
				});
				nextButton.addEventListener('click', function () {
					splide.go('>'); // Move to the next slide
				});
			},
		}
		jQuery(document).ready(fn.init);
	}
	new RelatedPostsSlider();
})();